/** @jsx jsx */
import { Status, StatusVariant } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { IConsultantProfile } from "@/data/consultant-profiles";
import { ConsultantProfileActiveType } from "@/data/consultant-profiles/types/ConsultantProfileActiveType";
import { getConsultantProfileActiveType } from "@/data/consultant-profiles/utils/getConsultantProfileActiveType";

const mapTypeToStatusVariant: Record<ConsultantProfileActiveType, StatusVariant> = {
  ACTIVE: "success",
  BLOCKED: "danger",
  PENDING: "secondary",
};

const mapTypeToTranslationKey: Record<ConsultantProfileActiveType, string> = {
  ACTIVE: "CONSULTANT_PROFILES.ACTIVE_TYPE.ACTIVE",
  BLOCKED: "CONSULTANT_PROFILES.ACTIVE_TYPE.BLOCKED",
  PENDING: "CONSULTANT_PROFILES.ACTIVE_TYPE.PENDING",
};

interface ConsultantProfileActiveStatusProps {
  profile: IConsultantProfile;
}

export const ConsultantProfileActiveStatus: FC<ConsultantProfileActiveStatusProps> = ({ profile }) => {
  const { t } = useTranslation("session");

  const type = getConsultantProfileActiveType(profile);

  const variant = mapTypeToStatusVariant[type];
  const translationKey = mapTypeToTranslationKey[type];

  return <Status variant={variant}>{t(translationKey)}</Status>;
};
